import { defineMessages } from "@/i18n";
import en from "./en";

export const wallMessages = defineMessages("wall", en);
